<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2">Source</div>
            <vx-box color="info" class="p-4">
                <div class="flex flex-col gap-3">
                    <div
                        v-for="sourceOption in sourceOptions"
                        :key="sourceOption.label"
                        class="flex gap-2 items-center text-sm cursor-pointer"
                        :data-test="`source-${sourceOption.value}`"
                        @click.prevent="filters.source = sourceOption.value"
                        @keydown.space.prevent="filters.source = sourceOption.value"
                        @keydown.enter.prevent="filters.source = sourceOption.value"
                    >
                        <vx-radio :modelValue="filters.source === sourceOption.value"></vx-radio>
                        {{ sourceOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { VxBox, VxRadio } from '@voxie/frontend-components';
import { sourceLabels } from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrListParams } from '~/services/adminTenDlcClient.types';

const sourceOptions: { label: string; value: TcrListParams['source'] }[] = [
    { label: 'All', value: undefined },
    { label: sourceLabels.tcr, value: 'tcr' },
    { label: sourceLabels.twilio, value: 'twilio' },
];

const filters = defineModel<TcrListParams>({ default: () => ({}) });
</script>
